import React from 'react';
import { TextCustom } from '../../ui/TextCustom';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { mappingGermanToEnglish } from '../../../utils/mapping';

export const Department = () => {
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    return (
        <TextCustom weight={400} color="grey-dark" size={1.2}>
            {mappingGermanToEnglish(userAndTokenData?.user.department || '') || 'Operator'}
        </TextCustom>
    );
};
